import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { IboxtoolsComponent } from './iboxtools.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [IboxtoolsComponent],
    imports: [CommonModule, BsDropdownModule.forRoot()],
    exports: [IboxtoolsComponent],
})
export class IboxtoolsModule {}
